module.exports = "/_next/static/images/9528a395925feddfb67b46858c4edfb9-digital-account-phone-main-screen@md-1x.png";